import { useEffect } from 'react';
import $ from 'jquery';
import 'ion-rangeslider';

export default function useIonRangeSlider(ref, settings) {
  useEffect(() => {
    if (!ref.current) return;
    const instance = $(ref.current).data('ionRangeSlider');
    if (instance) {
      instance.update(settings);
    } else {
      $(ref.current).ionRangeSlider(settings);
    }
  }, [ref, settings]);
}
